(function () {
  var STORAGE_KEY = 'wdCartReminderSince';
  var DELAY_MS = 15 * 60 * 1000;
  var REMINDER_TITLE = 'Bijna klaar - voltooi je bestelling';
  var originalTitle = document.title;
  var timerId = null;
  var titleActive = false;

  function showReminder() {
    if (titleActive) return;
    titleActive = true;
    document.title = REMINDER_TITLE;
  }

  function restoreTitle() {
    titleActive = false;
    if (document.title === REMINDER_TITLE) {
      document.title = originalTitle;
    }
  }

  function scheduleCheck(itemCount) {
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }

    if (itemCount > 0) {
      var since = localStorage.getItem(STORAGE_KEY);
      var now = Date.now();

      if (!since) {
        since = now;
        localStorage.setItem(STORAGE_KEY, String(since));
      }

      var remaining = DELAY_MS - (now - Number(since));

      if (remaining <= 0) {
        showReminder();
      } else {
        timerId = setTimeout(showReminder, remaining);
      }
    } else {
      localStorage.removeItem(STORAGE_KEY);
      restoreTitle();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleCheck(window.wdInitialCartCount || 0);
  });

  document.addEventListener('cart:updated', function (event) {
    var count = event.detail && event.detail.cart ? event.detail.cart.item_count : 0;
    scheduleCheck(count);
  });
})();
